
import { Component } from '@angular/core';
import { App, NavController, NavParams } from 'ionic-angular';
import "rxjs";
import { Observable } from 'rxjs';
import { MyEventListModel } from '../../../../providers/event/event';
import { EventCreateTabsPage } from '../../../event/create/event-create-tabs/event-create-tabs';

/**
 * Generated class for the MysportEventsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-mysport-events',
  templateUrl: 'mysport-events.html',
})
export class MysportEventsPage {
  events: MyEventListModel[] = [];
  constructor(
    public navCtrl: NavController,
    public app: App,
    public navParams: NavParams
  ) {
    console.log(navParams)
    this.events = navParams.data.data;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad MysportEventsPage');
  }

  removed(id: number) {
    Observable.from(this.events).filter(x => x.id !== id).toArray().toPromise()
      .then((list: MyEventListModel[]) => this.events = list);
  }

  showNewEvent() {
    this.app.getRootNav().push(EventCreateTabsPage);
  }

  onDelete(ev) {
    console.log(ev);
  }

}



// WEBPACK FOOTER //
// /src/pages/me/mysport/mysport-events/mysport-events.ts